import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Index from "./pages/Index";
import Services from "./pages/Services";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BookEstimate from "./pages/BookEstimate";
import NotFound from "./pages/NotFound";
import EstateCleanout from "./pages/services/EstateCleanout";
import ForeclosureCleanout from "./pages/services/ForeclosureCleanout";
import EvictionCleanout from "./pages/services/EvictionCleanout";
import StorageUnitCleanout from "./pages/services/StorageUnitCleanout";
import HoarderCleanout from "./pages/services/HoarderCleanout";
import CommercialPropertyCleanout from "./pages/services/CommercialPropertyCleanout";
import ApartmentTurnover from "./pages/services/ApartmentTurnover";
import InteriorDemolition from "./pages/services/InteriorDemolition";
import KitchenDemolition from "./pages/services/KitchenDemolition";
import BathroomDemolition from "./pages/services/BathroomDemolition";
import BasementDemolition from "./pages/services/BasementDemolition";
import FlooringRemoval from "./pages/services/FlooringRemoval";
import CommercialInteriorDemolition from "./pages/services/CommercialInteriorDemolition";
import ThankYou from "./pages/ThankYou";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Index />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/interior-demolition-wisconsin" element={<InteriorDemolition />} />
            <Route path="/services/kitchen-demolition-wisconsin" element={<KitchenDemolition />} />
            <Route path="/services/bathroom-demolition-wisconsin" element={<BathroomDemolition />} />
            <Route path="/services/basement-demolition-wisconsin" element={<BasementDemolition />} />
            <Route path="/services/flooring-removal-wisconsin" element={<FlooringRemoval />} />
            <Route path="/services/commercial-interior-demolition-wisconsin" element={<CommercialInteriorDemolition />} />
            <Route path="/services/estate-cleanout-wisconsin" element={<EstateCleanout />} />
            <Route path="/services/foreclosure-cleanout-wi" element={<ForeclosureCleanout />} />
            <Route path="/services/eviction-cleanout-wi" element={<EvictionCleanout />} />
            <Route path="/services/storage-unit-cleanout-wi" element={<StorageUnitCleanout />} />
            <Route path="/services/hoarder-cleanout-wi" element={<HoarderCleanout />} />
            <Route path="/services/commercial-property-cleanout-wi" element={<CommercialPropertyCleanout />} />
            <Route path="/services/apartment-turnover-wi" element={<ApartmentTurnover />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/book" element={<BookEstimate />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
